import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { FormattedMessage } from 'react-intl'

function Button({name, icon, children, color, onClick, appearance, fillSpace, className, disabled, testId}:{className?: any, name?: string, children?:any, color:string, onClick: (event?:any) => void, appearance?: "outline"|"full", fillSpace?: boolean, icon?:any, disabled?: boolean, testId?: string}) {
  const handleClick = (event: any) => {
    if (!disabled) {
      onClick(event);
    }
  };

  if(appearance === "outline")
  return <div data-testid={testId ?? (name ? `button-${name}` : undefined)} role="button" aria-disabled={disabled} onClick={handleClick} className={
    `w-fit px-4 py-1 border-${color} border-2 rounded-full text-center m-auto flex justify-center items-center` +
    (fillSpace ? " !w-full h-[44px] my-0 " : " ") +
    (disabled ? " opacity-50 cursor-not-allowed " : " cursor-pointer ") + className
  }>
    {name && <FormattedMessage id={name} />}
    {children}
    {icon && <FontAwesomeIcon className='ml-2' icon={icon} />}
  </div>

  return (
    <div data-testid={testId ?? (name ? `button-${name}` : undefined)} role="button" aria-disabled={disabled} onClick={handleClick} className={
      `px-4 w-fit py-1 bg-${color} rounded-full text-center mx-auto flex justify-center items-center` +
      (fillSpace ? " !w-full h-[44px] my-0 " : " ") +
      (disabled ? " opacity-50 cursor-not-allowed " : " cursor-pointer ") + className
  }>
    {name && <FormattedMessage id={name} />}
    {children}
    {icon && <FontAwesomeIcon className='ml-2' icon={icon} />}
    </div>
  )
}

export default Button
